import { getInitialSurveyState, updateSurveyDirectSharing, updateSurveyFolder, UpdateSurveyInitialState, updateSurveyNoDirectShareNoFolder, } from "./update-survey-helper";
export var useUpdateSearch = function (updateSurvey, setSurveys, selectedSurvey, setSelectedSurvey, newFolderName, createSavedSearchFolder, setFolders, removeSavedSearchFromFolder, getSubjectsFromContacts, setSurveyContacts, updateFolders, removeSurveyFromSharing, getSurveyDirectSharingCollaborators) {
    return function (id, request, collaborators, collaboratorsToRemove) {
        (function () {
            var initialSurveyState = getInitialSurveyState(selectedSurvey);
            if (updateSurvey &&
                createSavedSearchFolder &&
                setSurveys &&
                setSelectedSurvey &&
                setFolders &&
                setSurveyContacts &&
                getSubjectsFromContacts &&
                removeSavedSearchFromFolder &&
                updateFolders &&
                removeSurveyFromSharing &&
                getSurveyDirectSharingCollaborators) {
                switch (initialSurveyState) {
                    case UpdateSurveyInitialState.Folder:
                        return updateSurveyFolder(id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey, removeSavedSearchFromFolder);
                    case UpdateSurveyInitialState.DirectShare:
                        return updateSurveyDirectSharing(id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators);
                    case UpdateSurveyInitialState.NoDirectShareNoFolder:
                        return updateSurveyNoDirectShareNoFolder(id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey);
                }
            }
        })();
    };
};
//# sourceMappingURL=use-update-search.js.map